import React, { Component } from "react";
import "./TicketListOverlay.scss";
import { DefaultButton, PrimaryButton, Stack, TextField, Label, IconButton, TooltipHost, FontIcon } from "office-ui-fabric-react";
import { Panel, PanelType } from "office-ui-fabric-react/lib/Panel";
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { ComboBox, Spinner, Text } from 'office-ui-fabric-react/lib/';
import { queryGetEmailList, mutationUpdateTicket, queryGetTickets, mutationCreateTicketComment, queryGetTicketDocuments } from "../../../queries/querySettings";
import { Query } from "react-apollo";
import { MyContext } from '../../../context';
import { toast } from "react-toastify";

const dropdownStyles = {
    dropdown: { width: 250 }
};

export default class TicketListOverlay extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.allowedTenantsList = [];
        // Collect Tenant ComboBox
        if (this.props.userRules.allowedTenants != null) {
            for (let x = 0; x < this.props.userRules.allowedTenants.length; x++) {
                this.allowedTenantsList.push({ key: this.props.userRules.allowedTenants[x].id, text: this.props.userRules.allowedTenants[x].name });
            }
        }
        this.styles = {
            root: {
                paddingTop: "20px"
            },
            marginLeft: {
                marginLeft: "10px"
            }
        };

        this.validateEmail = (email) => {
            if (!email) return true;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        };

        this.state = {
            title: "",
            priority: "",
            caseId: "",
            state: "",
            description: "",
            contactEmail: "",
            id: null,
            created: "",
            changed: "",
            comment: "",
            isPanelOpen: false,
            documentUpload: "",
            files: [],
            deletedFiles: [],
            closedDate: ""
        };
    }



    render() {
        return (
            <Panel
                isOpen={this.state.isPanelOpen}
                onDismiss={this.hidePanel}
                isFooterAtBottom={false}
                headerText=""
                headerClassName="panel-header"
                type={PanelType.smallFluid}
            >
                <Stack vertitcal>
                    <Stack.Item styles={this.styles}>
                        <Stack>
                            <Stack.Item>
                                <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "ticketCaseId")}</>)}</MyContext.Consumer>}
                                    value={this.state.caseId}
                                    onKeyDown={this._handleKeyDown}
                                    disabled
                                />
                                <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "ticketCreated")}</>)}</MyContext.Consumer>}
                                    value={this.state.created}
                                    onKeyDown={this._handleKeyDown}
                                    disabled
                                />
                                <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "ticketChanged")}</>)}</MyContext.Consumer>}
                                    value={this.state.changed}
                                    onKeyDown={this._handleKeyDown}
                                    disabled
                                />
                                {this.state.closedDate && < TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "ticketClosedDate")}</>)}</MyContext.Consumer>}
                                    value={this.state.closedDate}
                                    onKeyDown={this._handleKeyDown}
                                    disabled
                                />}
                                {this.props.userRules.allowedTenants != null && this.props.userRules.allowedTenants.length > 0 &&
                                    <Stack.Item>
                                        <ComboBox
                                            defaultSelectedKey={this.state.tenantId}
                                            selectedKey={this.state.tenantId}
                                            options={this.allowedTenantsList}
                                            label={"TenantId"}
                                            disabled
                                        />
                                    </Stack.Item>
                                }
                                <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "ticketState")}</>)}</MyContext.Consumer>}
                                    value={this.state.state}
                                    onKeyDown={this._handleKeyDown}
                                    disabled
                                />
                                <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "ticketTitle")}</>)}</MyContext.Consumer>}
                                    onChange={(event) => { this.handleChange(event.target.value, 0) }}
                                    value={this.state.title}
                                    onKeyDown={this._handleKeyDown}
                                />
                                <TextField label={
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <MyContext.Consumer>{(context) => (<> {context.getTranslation("detailContainer", "email")}</>)}</MyContext.Consumer>
                                        <TooltipHost content="Add your email." styles={{ root: { marginLeft: 6 } }}>
                                            <FontIcon iconName="Info" style={{ cursor: 'pointer', fontSize: 14 }} />
                                        </TooltipHost>
                                    </div>
                                    }
                                    onChange={(event) => { this.handleChange(event.target.value, 4) }}
                                    value={this.state.contactEmail}
                                    onKeyDown={this._handleKeyDown}
                                    errorMessage={this.state.contactEmail && !this.validateEmail(this.state.contactEmail) ? "Invalid email address" : ""}
                                />
                                <Dropdown
                                    selectedKey={this.state.priority}
                                    onChange={(event, item) => { this.handleChange(item.key, 1) }}
                                    label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "ticketPriority")}</>)}</MyContext.Consumer>}
                                    options={[
                                        { key: 'SOS', text: 'SOS' },
                                        { key: 'Critical', text: 'Prio 1' },
                                        { key: 'Major', text: 'Prio 2' },
                                        { key: 'Minor', text: 'Prio 3' }
                                    ]}
                                    styles={dropdownStyles}
                                />

                                {/*upload a file*/}
                                <Label>{<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "uploadDocument")}</>)}</MyContext.Consumer>}</Label>
                                <div>
                                    <input type="file" onChange={this.onFileChange} id="file-btn" style={{ display: 'none' }} />
                                    <DefaultButton text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "Upload")}</>)}</MyContext.Consumer>} onClick={() => document.getElementById('file-btn').click()} />
                                </div>


                                {/* Display uploaded files */}
                                {this.state.files.length > 0 && <Label>{<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "attachedDocuments")}</>)}</MyContext.Consumer>}</Label>}

                                <ul style={{ listStyleType: 'none', padding: 0 }}>
                                    {this.state.files.map((file, index) => (
                                        <li key={index} style={{ display: 'flex', alignItems: 'center' }}>
                                            <IconButton
                                                iconProps={{ iconName: 'Delete' }}
                                                title="Delete"
                                                ariaLabel="Delete"
                                                onClick={() => this.deleteFile(index)}
                                                style={{ marginRight: '8px' }}
                                            />
                                            <a href={file.documentBody} download={file.filename}>
                                                {file.filename}
                                            </a>
                                        </li>
                                    ))}
                                </ul>

                                <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "ticketDescription")}</>)}</MyContext.Consumer>}
                                    onChange={(event) => { this.handleChange(event.target.value, 3) }}
                                    value={this.state.description}
                                    onKeyDown={this._handleKeyDown}
                                    multiline rows={10}
                                />
                            </Stack.Item>
                        </Stack>
                    </Stack.Item>

                    <Stack.Item styles={this.styles}>
                        <Stack vertical>
                            <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "ticketComment")}</>)}</MyContext.Consumer>}
                                value={this.state.comment}
                                onChange={(event) => { this.setState({ comment: event.target.value }) }}
                                multiline
                                rows={5}
                            />
                            <Stack.Item align="end" styles={this.styles}>
                                <DefaultButton disabled={this.state.comment === ""} onClick={(event) => { this.notifyTicketEmail(this.props.apol), this.setState({ comment: "" }) }} text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "save")}</>)}</MyContext.Consumer>} />
                            </Stack.Item>
                        </Stack>
                    </Stack.Item>
                    <br />
                    <br />
                    <Stack.Item styles={this.styles}>
                        <Stack horizontal horizontalAlign="end">
                            <Stack.Item >
                                <PrimaryButton
                                    id="saveBtn"
                                    onClick={(event) => { this.notifyTenantChange(this.props.apol); this.setState({ isPanelOpen: false }) }}
                                    text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "save")}</>)}</MyContext.Consumer>} disabled={!this.state.isChanged} />
                            </Stack.Item>
                            <Stack.Item style={this.styles.marginLeft}>
                                <DefaultButton onClick={(event) => { this.setState({ isPanelOpen: false }) }} text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "cancel")}</>)}</MyContext.Consumer>} />

                            </Stack.Item>
                        </Stack>
                    </Stack.Item>

                    <Stack.Item styles={this.styles}>
                        <Stack vertical>
                            <Query
                                query={queryGetEmailList}
                                fetchPolicy="network-only"
                                variables={{ id: this.state.id, tenantId: this.state.tenantId, auth: this.props.auth }}  >
                                {({ loading, error, data }) => {
                                    if (loading) return <Stack vertical className={window.innerWidth < 600 ? "GridItem-content-small" : "GridItem-content"} ><Spinner label="Load Emails" ariaLive="assertive" labelPosition="top" /></Stack>;
                                    if (error) return <Stack vertical className={window.innerWidth < 600 ? "GridItem-content-small" : "GridItem-content"} ></Stack>;
                                    if (data.getEmailList == null) return <Stack vertical className={window.innerWidth < 600 ? "GridItem-content-small" : "GridItem-content"} ><Text className="ContentColor" variant="mediumPlus">Emails</Text></Stack>
                                    return data.getEmailList.map(({ id, subject, from, to, created, changed, text }, i) =>
                                    (
                                        <div key={id}>
                                            <Text variant="large"><MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "ticketMail")}</>)}</MyContext.Consumer> {created}</Text>
                                            <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "ticketSubject")}</>)}</MyContext.Consumer>}
                                                value={subject}
                                                disabled
                                            />
                                            <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "ticketFrom")}</>)}</MyContext.Consumer>}
                                                value={from}
                                                disabled
                                            />
                                            <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "ticketTo")}</>)}</MyContext.Consumer>}
                                                value={to}
                                                disabled
                                            />
                                            <Text variant="medium"><MyContext.Consumer>{(context) => (<> {context.getTranslation("settings", "ticketContent")}</>)}</MyContext.Consumer></Text>
                                            <div dangerouslySetInnerHTML={{ __html: text }}></div> <br />
                                        </div>
                                    ))
                                }}
                            </Query>
                        </Stack>
                    </Stack.Item>
                </Stack>
            </Panel>
        );
    }

    handleChange(text, id) {
        switch (id) {
            case 0: this.setState({ title: text }); break;
            case 1: this.setState({ priority: text }); break;
            case 2: this.setState({ state: text }); break;
            case 3: this.setState({ description: text }); break;
            case 4: this.setState({ contactEmail: text }); break;

            default: break;
        }
        // Decide to set isChanged
        const currentEmail = id === 4 ? text : this.state.contactEmail;
        const isEmailValid = !currentEmail || this.validateEmail(currentEmail);
        if (
            (id === 0 ? text : this.state.title) !== ""
            && (id === 3 ? text : this.state.description) !== ""
            && isEmailValid
        ) {
            this.setState({ isChanged: true });
        } else {
            this.setState({ isChanged: false });
        }
    }



    fetchTicketDocuments = async (id) => {
        const { data } = await this.props.apol.query({
            query: queryGetTicketDocuments,
            variables: { id: id, tenantId: this.state.tenantId, auth: this.props.authorization }
        });

        if (data && data.getTicketDocuments) {
            const files = data.getTicketDocuments.map(doc => ({
                filename: doc.filename,
                mimeType: doc.mimeType,
                documentBody: doc.documentBody,
                annotationId: doc.annotationId,
                isDeleted: doc.isDeleted
            }));

            this.setState({ files });
        }
        return [];
    };
    deleteFile = (index) => {
        this.setState(prevState => {
            const files = [...prevState.files];
            const fileToDelete = files[index];
            files.splice(index, 1);

            if (fileToDelete.annotationId !== null) {
                const deletedFiles = [...prevState.deletedFiles, { ...fileToDelete, isDeleted: true }];
                return { files, deletedFiles, isChanged: true };
            }

            return { files, isChanged: true };
        });
    };

    onFileChange = event => {
        let activeFile = event.target.files[0];

        if (activeFile) {
            this.setState({ isChanged: true });
            this.loadFile(activeFile);
        }
    };

    loadFile = async (file) => {
        let reader = new FileReader();
        reader.onloadend = () => {
            const newFile = {
                filename: file.name,
                mimeType: file.type,
                documentBody: reader.result,
                annotationId: null,
                isDeleted: false
            };

            this.setState(prevState => ({
                files: [...prevState.files, newFile]
            }));

        };
        reader.readAsDataURL(file);
    };


    notifyTenantChange = async (apol) => {
        const documents = [...this.state.files, ...this.state.deletedFiles];

        var ticket = {
            title: this.state.title,
            priority: this.state.priority,
            caseId: this.state.caseId,
            description: this.state.description,
            contactEmail: this.state.contactEmail,
            tenantId: this.state.tenantId,
            id: this.state.id,
            documents: documents
        };

        var data = await apol
            .mutate({
                mutation: mutationUpdateTicket,
                refetchQueries: [{
                    query: queryGetTickets,
                    variables: { input: this.props.authorization, tenantId: null, asPartner: true },
                }],
                variables: {
                    ticket: ticket
                }
            });
        if (data.data.updateTicket == null || !data.data.updateTicket) {
            toast.info(<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addTicketNotSuccessful")}</>)}</MyContext.Consumer>, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            toast.info(<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "ticketAdded")}</>)}</MyContext.Consumer>, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }

    };

    notifyTicketEmail = async (apol) => {
        // Create Email
        var ticket = {
            title: this.state.title,
            priority: this.state.priority,
            caseId: this.state.caseId,
            description: this.state.description,
            contactEmail: this.state.contactEmail,
            tenantId: this.state.tenantId,
            id: this.state.id
        };

        var data = await apol
            .mutate({
                mutation: mutationCreateTicketComment,
                variables: {
                    ticket: ticket,
                    comment: this.state.comment
                }
            });
        if (data.data.createTicketComment == null || !data.data.createTicketComment) {
            toast.info(<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "createTicketCommentNotSuccessful")}</>)}</MyContext.Consumer>, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            toast.info(<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "createTicketCommentSuccessful")}</>)}</MyContext.Consumer>, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });

        }
    };

    showPanelItem = async ({ title, priority, caseId, state, description, contactEmail, id, created, changed, comment, closedDate }) => {
        this.setState({
            title,
            priority,
            caseId,
            state,
            description,
            contactEmail,
            id,
            created,
            changed,
            comment,
            closedDate,
            isPanelOpen: true,
        });
    };

    hidePanel = () => {
        this.setState({ id: null, isPanelOpen: false });
    };
}
